import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../css/Header.css';
import defaultLogo from '../images/default-logo.webp';
import { useCredits } from '../components/CreditsContext';
import { useAuth } from '../contexts/AuthContext';

function Header() {
  const location = useLocation();
  const { screeningCredits, talentRolePass, shortlistPass } = useCredits();
  const { logout, currentUser } = useAuth();

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const handleLogout = async () => {
    try {
      await logout();
      // Redirect to ExodiaUno website after logout
      window.location.href = 'https://uno.exodiagamedev.com/';
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="logo-section">
          <div className="logo-icon">
            <div className="logo-glow">
              <img src={defaultLogo} alt="ExodiaUno Logo" className="logo-image" />
            </div>
          </div>
          {/* <span className="logo-text">ExodiaUno</span> */}
        </div>

        <nav className="navigation-menu nav--stacked">
          <Link to="/home" className={`nav-item ${isActive('/home')}`}>
            <span className="nav-icon">🏠</span>
            <span className="nav-text">Home</span>
          </Link>
          <Link to="/role-deck" className={`nav-item ${isActive('/role-deck')}`}>
            <span className="nav-icon">👤</span>
            <span className="nav-text">Role Deck</span>
          </Link>
          <Link to="/talent-pool" className={`nav-item ${isActive('/talent-pool')}`}>
            <span className="nav-icon">🫂</span>
            <span className="nav-text">Talent Pool</span>
          </Link>
          <Link to="/squad-tracker" className={`nav-item ${isActive('/squad-tracker')}`}>
            <span className="nav-icon">👥</span>
            <span className="nav-text">Squad Tracker</span>
          </Link>
          <Link to="/my-heroes" className={`nav-item ${isActive('/my-heroes')}`}>
            <span className="nav-icon">⚔️</span>
            <span className="nav-text">My Heroes</span>
          </Link>
          <Link to="/knowledge-hub" className={`nav-item ${isActive('/knowledge-hub')}`}>
            <span className="nav-icon">📚</span>
            <span className="nav-text">Knowledge Hub</span>
          </Link>

          {/* Numbers-as-icons */}
          <Link
            to={{ pathname: "/profile", search: "?tab=subscription", state: { openTab: "subscription", via: "header-shortlist-pass" } }}
            className={`nav-item nav-item--count accent-tertiary`}
            aria-label={`Shortlist Pass`}
            title="Shortlist Pass"
          >
            <span className="nav-number">{shortlistPass}</span>
            <span className="nav-text">Shortlist Pass</span>
          </Link>
          
          <Link
            to={{ pathname: "/profile", search: "?tab=subscription", state: { openTab: "subscription", via: "header-credits" } }}
            className={`nav-item nav-item--count accent-primary `}
            aria-label={`Screening Credits`}
            title="Screening Credits"
          >
            <span className="nav-number">{screeningCredits}</span>
            <span className="nav-text">Screening Credits</span>
          </Link>

          <Link
            to={{ pathname: "/profile", search: "?tab=subscription", state: { openTab: "subscription", via: "header-role-pass" } }}
            className={`nav-item nav-item--count accent-secondary`}
            aria-label={`Talent Role Pass`}
            title="Talent Role Pass"
          >
            <span className="nav-number">{talentRolePass}</span>
            <span className="nav-text">Talent Role Pass</span>
          </Link>

          {/* User Profile Dropdown */}
          {currentUser && (
            <div className="nav-user-section">
              <div className="profile-dropdown">
                <button 
                  className="nav-item nav-item--profile"
                  title="Profile Menu"
                  aria-label="Profile Menu"
                >
                  <span className="nav-icon">👤</span>
                  <span className="nav-text">Profile</span>
                </button>
                <div className="profile-dropdown-menu">
                  <Link to="/profile" className="dropdown-item">
                    <span className="dropdown-text">View Profile</span>
                  </Link>
                  <button 
                    onClick={handleLogout}
                    className="dropdown-item dropdown-logout"
                  >
                    <span className="dropdown-text">Logout</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
